module.exports = __webpack_public_path__ + "img/identity-camera.fc12df5a.png";